<div
  class="bg-white rounded-xl border border-slate-200 p-5 sm:p-6 hover:shadow-md transition-shadow duration-150"
>
  <div class="flex items-center justify-between">
    <div>
      <div class="flex items-center gap-2">
        <p class="text-slate-500 text-sm font-medium">{{ titulo() }}</p>
        @if (tooltip()) {
          <i
            class="bi bi-info-circle text-slate-400 text-sm cursor-help"
            [appTooltip]="tooltip()!"
            tooltipPosition="top"
          ></i>
        }
      </div>
      <p class="text-2xl md:text-3xl font-bold text-slate-900 mt-2">{{ valor() }}</p>
    </div>
    <div
      class="w-12 h-12 rounded-xl flex items-center justify-center"
      [class.bg-accent-50]="color() === 'blue'"
      [class.bg-emerald-50]="color() === 'green'"
      [class.bg-amber-50]="color() === 'yellow'"
      [class.bg-red-50]="color() === 'red'"
      [class.bg-purple-50]="color() === 'purple'"
    >
      <i
        class="text-lg {{ icono() }}"
        [class.text-accent-600]="color() === 'blue'"
        [class.text-emerald-600]="color() === 'green'"
        [class.text-amber-600]="color() === 'yellow'"
        [class.text-red-600]="color() === 'red'"
        [class.text-purple-600]="color() === 'purple'"
      ></i>
    </div>
  </div>
</div>
